import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const DatenschutzPage = () => {
  return (
    <div data-testid="datenschutz-page" className="min-h-screen bg-stone-50">
      <Navigation />
      <main className="pt-24 pb-16">
        <div className="container-custom">
          <Link 
            to="/" 
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 mb-8 font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          
          <div className="glass-card rounded-3xl p-8 md:p-12 max-w-4xl">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 font-[Outfit]">
              Datenschutzerklärung
            </h1>
            
            <div className="space-y-8 text-slate-600 leading-relaxed">

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  1. Datenschutz auf einen Blick
                </h2>
                <h3 className="text-lg font-medium text-slate-700 mb-2">Allgemeine Hinweise</h3>
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                  personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                  Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. 
                  Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter 
                  diesem Text aufgeführten Datenschutzerklärung.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  2. Verantwortliche Stelle
                </h2>
                <p>
                  Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                </p>
                <p className="mt-2">
                  Jennifer Laak<br />
                  Franz-Hartz-Straße 17<br />
                  47839 Krefeld<br /><br />
                  Telefon: 0172 1697433<br />
                  E-Mail: jennifer-laak@gmx.de
                </p>
                <p className="mt-2">
                  Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
                  gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen 
                  Daten (z.B. Namen, E-Mail-Adressen o.Ä.) entscheidet.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  3. Datenerfassung auf dieser Website
                </h2>
                <h3 className="text-lg font-medium text-slate-700 mb-2">
                  Wer ist verantwortlich für die Datenerfassung auf dieser Website?
                </h3>
                <p>
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
                  Kontaktdaten können Sie dem Abschnitt „Verantwortliche Stelle" in dieser 
                  Datenschutzerklärung entnehmen.
                </p>
                
                <h3 className="text-lg font-medium text-slate-700 mb-2 mt-4">
                  Wie erfassen wir Ihre Daten?
                </h3>
                <p>
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann 
                  es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                </p>
                <p className="mt-2">
                  Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website 
                  durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, 
                  Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt 
                  automatisch, sobald Sie diese Website betreten.
                </p>

                <h3 className="text-lg font-medium text-slate-700 mb-2 mt-4">
                  Wofür nutzen wir Ihre Daten?
                </h3>
                <p>
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu 
                  gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. 
                  Sofern über die Website Verträge geschlossen oder angebahnt werden können, werden die 
                  übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige 
                  Auftragsanfragen verarbeitet.
                </p>

                <h3 className="text-lg font-medium text-slate-700 mb-2 mt-4">
                  Welche Rechte haben Sie bezüglich Ihrer Daten?
                </h3>
                <p>
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und 
                  Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein 
                  Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine 
                  Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit 
                  für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die 
                  Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren 
                  steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                </p>
                <p className="mt-2">
                  Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  4. Hosting
                </h2>
                <p>
                  Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                </p>
                <p className="mt-2">
                  Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein 
                  berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. 
                  Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung 
                  ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  5. Allgemeine Hinweise und Pflichtinformationen – Datenschutz
                </h2>
                <p>
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                  Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen 
                  Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
                <p className="mt-2">
                  Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. 
                  Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. 
                  Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir 
                  sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                </p>
                <p className="mt-2">
                  Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation 
                  per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem 
                  Zugriff durch Dritte ist nicht möglich.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  6. Widerruf Ihrer Einwilligung zur Datenverarbeitung
                </h2>
                <p>
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
                  Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit 
                  der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  7. Widerspruchsrecht gegen die Datenerhebung (Art. 21 DSGVO)
                </h2>
                <p>
                  Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, 
                  haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen Situation 
                  ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen. 
                  Die jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen Sie dieser 
                  Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre betroffenen 
                  personenbezogenen Daten nicht mehr verarbeiten.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  8. Beschwerderecht bei der zuständigen Aufsichtsbehörde
                </h2>
                <p>
                  Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei 
                  einer Aufsichtsbehörde zu, insbesondere in dem Mitgliedstaat ihres gewöhnlichen 
                  Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes. Das 
                  Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder 
                  gerichtlicher Rechtsbehelfe.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  9. Recht auf Datenübertragbarkeit
                </h2>
                <p>
                  Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung 
                  eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, 
                  maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der 
                  Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch 
                  machbar ist.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  10. SSL- bzw. TLS-Verschlüsselung
                </h2>
                <p>
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher 
                  Inhalte, wie zum Beispiel Anfragen, die Sie an uns als Seitenbetreiber senden, eine 
                  SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass 
                  die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem 
                  Schloss-Symbol in Ihrer Browserzeile.
                </p>
                <p className="mt-2">
                  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an 
                  uns übermitteln, nicht von Dritten mitgelesen werden.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  11. Auskunft, Löschung und Berichtigung
                </h2>
                <p>
                  Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf 
                  unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft 
                  und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung 
                  oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene 
                  Daten können Sie sich jederzeit an uns wenden.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  12. Recht auf Einschränkung der Verarbeitung
                </h2>
                <p>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Dies gilt in folgenden Fällen:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten.</li>
                  <li>Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht.</li>
                  <li>Wenn Sie die Löschung Ihrer personenbezogenen Daten ablehnen und stattdessen die Einschränkung verlangen.</li>
                  <li>Wenn der Zweck der Datenverarbeitung entfallen ist, wir die Daten aber noch für Rechtsansprüche benötigen.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  13. Kontaktformular
                </h2>
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                  Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                  der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben 
                  wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p className="mt-2">
                  Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                  sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung 
                  vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die 
                  Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns 
                  gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 
                  Abs. 1 lit. a DSGVO).
                </p>
                <p className="mt-2">
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur 
                  Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die 
                  Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen – insbesondere 
                  Aufbewahrungsfristen – bleiben unberührt.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  14. Cookies
                </h2>
                <p>
                  Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Rechner 
                  abgelegt werden und die Ihr Browser speichert. Sie richten keinen Schaden an und enthalten 
                  keine Viren.
                </p>
                <p className="mt-2">
                  Wir verwenden ausschließlich technisch notwendige Cookies, um unsere Website 
                  nutzerfreundlicher zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, 
                  bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch 
                  wiederzuerkennen.
                </p>
                <p className="mt-2">
                  Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert 
                  werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte 
                  Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen 
                  des Browsers aktivieren.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  15. Anfrage per E-Mail, Telefon oder Telefax
                </h2>
                <p>
                  Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive 
                  aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der 
                  Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir 
                  nicht ohne Ihre Einwilligung weiter.
                </p>
              </section>

              <section className="pt-4 border-t border-stone-200">
                <p className="text-sm text-slate-500">
                  Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline">e-recht24.de</a> (angepasst)
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DatenschutzPage;
